import { render, staticRenderFns } from "./plansSlider.vue?vue&type=template&id=a11f8440&scoped=true&"
import script from "./plansSlider.vue?vue&type=script&lang=js&"
export * from "./plansSlider.vue?vue&type=script&lang=js&"
import style0 from "./plansSlider.vue?vue&type=style&index=0&id=a11f8440&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11f8440",
  null
  
)

export default component.exports